import rand from './lib/rand'
import minutesConverter from './lib/minutesConverter'
import thumbnail from './lib/thumbnail'
import communities from './lib/communities'
import dateTimeFormater from './lib/dateTimeFormater'
import urlUtils from './lib/urlUtils'
import splitVideoTrackName from './lib/splitVideoTrackName'
import webcast from './lib/webcast'
import useOpacity from './lib/useOpacity'
import usePrevious from './lib/usePrevious'
import loadScript from './lib/loadScript'
import formatDuration from './lib/formatDuration'
import getEnvironment from './lib/getEnvironment'
import { EnvironmentObject as _EnvironmentObject, Environment } from './lib/getEnvironment/getEnvironment'
import getDateDiff from './lib/getDateDiff'
import getTextColorClass from './lib/getTextColorClass'
import featureImage from './lib/featureImage'
import webcastKeywordsConverter from './lib/webcastKeywordsConverter'
import playback from './lib/playback'
import browser from './lib/browser'
import cookie from './lib/cookie'
import devices from './lib/devices'
import { DeviceStats as _DeviceStats } from './lib/devices/devices'
import Logger, { debug } from './lib/Logger'
import ChatManager from './lib/chatManager'
import { ChatManagerInterface as _ChatManagerInterface } from './lib/chatManager/types'
import useInterval from './lib/useInterval'
import getColorClass from './lib/getColorClass'
import channel from './lib/channel'
import fileName from './lib/fileName'
import closestSelectorInDOM from './lib/closestSelectorInDOM'
import getSlugFromEventType from './lib/getSlugFromEventType'
import download from './lib/download'
import getEmbedCode from './lib/embed'
import capitalize from './lib/capitalize'
import title from './lib/title'
import fileSize from './lib/fileSize'
import intervalToDuration from './lib/intervalToDuration'
import isFullscreen from './lib/isFullscreen'
import getEmailType from './lib/getEmailType'
import useDimensions from './lib/useDimensions'
import isServerSide from './lib/isServerSide'
import removeTab from './lib/removeTab'
import virtualEvent from './lib/virtualEvent'
import sanitiseInput, { sanitiseInputAndPreventNewLine } from './lib/sanitiseInput'
import getUserPhotoUrl from './lib/getUserPhotoUrl'
import getBreakpointValue, { breakpointMobile } from './lib/getBreakpointValue'
import makeStringCanonical from './lib/makeStringCanonical'
import { startBandwidthTest, startNetworkTest } from './lib/talksService'
import closedCaptionsLanguages from './lib/closedCaptionLanguages'
import sanitize from './lib/sanitize'
import winstonLogger from './lib/winstonLogger'

export type EnvironmentObject = _EnvironmentObject
export type DeviceStats = _DeviceStats
export type ChatManagerInterface = _ChatManagerInterface

export * from './lib/nurtureTypes/types'

export {
  rand,
  minutesConverter,
  thumbnail,
  communities,
  dateTimeFormater,
  urlUtils,
  splitVideoTrackName,
  webcast,
  useOpacity,
  usePrevious,
  loadScript,
  formatDuration,
  getEnvironment,
  getDateDiff,
  getTextColorClass,
  featureImage,
  webcastKeywordsConverter,
  playback,
  browser,
  cookie,
  Logger,
  debug,
  devices,
  ChatManager,
  useInterval,
  getColorClass,
  channel,
  fileName,
  closestSelectorInDOM,
  getSlugFromEventType,
  Environment,
  download,
  getEmbedCode,
  capitalize,
  title,
  fileSize,
  intervalToDuration,
  isFullscreen,
  getEmailType,
  useDimensions,
  isServerSide,
  removeTab,
  virtualEvent,
  sanitiseInput,
  sanitiseInputAndPreventNewLine,
  getUserPhotoUrl,
  getBreakpointValue,
  breakpointMobile,
  makeStringCanonical,
  startBandwidthTest,
  startNetworkTest,
  closedCaptionsLanguages,
  sanitize,
  winstonLogger,
}

export default {
  getEnvironment
}
